import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import BtnOutlineGradient from '../common/button/BtnOutlineGradient';
import { NumericFormat } from 'react-number-format';
import { useState } from 'react';
import { getToken } from 'src/utils/auth';
import { postAPI } from 'src/utils/api';

type RowsDetailProps = {
  item: any;
  handleEditClick: (patientid: any) => void;
};

const RowsDetail: React.FC<RowsDetailProps> = (props) => {
  const dataRow = props.item;
  const [note, setNote] = useState(dataRow.quote_payment_note || '');

  const handleDeleteClick = (id: string) => {};
  
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setNote(event.target.value);
  };

  const handleSave = () => {
    try {
      const token = getToken();
      postAPI(`/patient/save-quote-payment-note?token=${token}`, {
        payment_note: note,
        patient_id: dataRow.patientid,
        id: dataRow.quote_id || dataRow.quoteid,
      }).then((res) => {
        if (res.code === 200) {
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      handleSave()
    }
  };

  return (
    <TableRow
      hover
      sx={{
        '&:last-child td, &:last-child th': { border: 0 },
      }}
    >
      <TableCell>{dataRow.patientno}</TableCell>
      <TableCell>{dataRow.fullname}</TableCell>
      <TableCell>-</TableCell>
      <TableCell>{dataRow.paymentdate}</TableCell>
      <TableCell>-</TableCell>
      <TableCell>
        <TextField
          // autoFocus
          margin='dense'
          id='note'
          // variant='standard'
          value={note || ''}
          onChange={(event) => handleChange(event)}
          onKeyDown={(event) => handleKeyDown(event)}
          onBlur={handleSave}
          sx={{ width: '104px' }}
          size="small"
        />
      </TableCell>
      <TableCell>
        <NumericFormat
          displayType='text'
          value={dataRow.amount}
          thousandSeparator
        />
      </TableCell>
      <TableCell>-</TableCell>
      <TableCell>
        <Stack
          mb={'10px'}
          direction={'row'}
          spacing={'8px'}
          justifyContent={'flex-end'}
        >
          <BtnOutlineGradient
            text='変更'
            handleButtonClick={() => props.handleEditClick(dataRow.patientid)}
          />
          <BtnOutlineGradient
            text='削除'
            handleButtonClick={() => handleDeleteClick(dataRow.id)}
            grandient='#DA4453'
            color='#DA4453'
          />
        </Stack>
      </TableCell>
    </TableRow>
  );
};

export default RowsDetail;
